import { Component, inject } from '@angular/core';
import { LEERPLUS } from '../../rid-game.utils';
import { RidHomeworkService } from '../../services/rid-homework.service';
import { RidJourneyService } from '../../services/rid-journey.service';

@Component({
  selector: 'rid-homework-debug-tab',
  imports: [],
  templateUrl: './rid-homework-debug-tab.html',
})
export class RidHomeworkDebugTab {
  protected readonly $lpApiService = inject(LEERPLUS.apiToken);
  protected readonly $ridHomeworkService = inject(RidHomeworkService);
  protected readonly $ridJourneyService = inject(RidJourneyService);

  linkFor(homeworkStopId: string) {
    return this.$lpApiService.state().homeworkLinks.stops.find((l) => l.homeworkStopId === homeworkStopId);
  }

  activityUidFor(homeworkStopId: string, configUid: string): string | undefined {
    return this.linkFor(homeworkStopId)?.assignmentActivityUids[configUid];
  }

  isFinished(activityUid: string | undefined): boolean {
    if (!activityUid) return false;
    return this.$lpApiService.state().activityProgress.some((p) => p.uid === activityUid && !!p.finished_timestamp);
  }
}
